import { useState, useEffect } from 'react';

interface MobileDetection {
  isMobile: boolean;
  isIOS: boolean;
  isAndroid: boolean;
}

export function useIsMobile(): MobileDetection {
  const [detection, setDetection] = useState<MobileDetection>({
    isMobile: false,
    isIOS: false,
    isAndroid: false,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
    
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isAndroid = /android/i.test(userAgent);
    const isMobile = isIOS || isAndroid || /webOS|BlackBerry|Opera Mini|IEMobile/i.test(userAgent);

    setDetection({
      isMobile,
      isIOS,
      isAndroid,
    });
  }, []);

  return detection;
}
